import { state, saveToLocalStorage } from '../state.js';
import { setupPrivacyPolicy } from './privacy-policy.js';
import { setupTermsOfSale } from './terms-of-sale.js';

export function setupSettings(onFormatChangeCallback) {
    // Privacy policy and terms of sale, opened from the Privacy and Terms
    // section of this page — and by zugzwang.no/?personvern and ?vilkar.
    setupPrivacyPolicy();
    setupTermsOfSale();

    // Theme Selection
    const themeSelect = document.getElementById('theme-select');
    
    if (themeSelect) {
        themeSelect.addEventListener('change', (e) => applyTheme(e.target.value));
    }
    
    // Initial theme application
    applyTheme(state.userProfile?.theme || 'light');

    // Name Format Selection
    const nameFormatSelect = document.getElementById('name-format-select');
    
    if (nameFormatSelect) {
        nameFormatSelect.addEventListener('change', (e) => applyNameFormat(e.target.value, onFormatChangeCallback));
    }

    // Initial name format application (without triggering callback during setup)
    applyNameFormat(state.userProfile?.nameFormat || 'first-last', null);

    // Language Selection
    const languageSelect = document.getElementById('language-select');
    if (languageSelect && window.i18n) {
        languageSelect.value = window.i18n.getLang();
        languageSelect.addEventListener('change', (e) => {
            const lang = e.target.value;
            if (!state.userProfile) state.userProfile = {};
            state.userProfile.lang = lang;
            saveToLocalStorage();
            // Persist + reload so both static HTML and dynamic strings switch cleanly.
            window.i18n.setLang(lang);
        });
    }
}

export function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    const themeSelect = document.getElementById('theme-select');
    if (themeSelect) themeSelect.value = theme;
    
    if (!state.userProfile) state.userProfile = {};
    state.userProfile.theme = theme;
    saveToLocalStorage();
}

export function applyNameFormat(format, callback) {
    const nameFormatSelect = document.getElementById('name-format-select');
    if (nameFormatSelect) nameFormatSelect.value = format;
    
    if (!state.userProfile) state.userProfile = {};
    state.userProfile.nameFormat = format;
    saveToLocalStorage();

    if (callback && typeof callback === 'function') {
        callback();
    }
}
